import React, { useContext } from 'react';
import LocaleContext from '../../../constants/localization';
import PasswordExpiryRadio from '../PasswordExpiryRadio';

const PasswordExpiryForm = ({
  edit = false,
  passwordExpiryInMonths,
  setPasswordExpiryInMonths,
  passwordExpiryRadio,
  setPasswordExpiryRadio,
  handlePasswordExpiryAll,
  handlePasswordExpiryNew,
}) => {
  const LS = useContext(LocaleContext);

  return (
    <form>
      <div style={{ marginBottom: '20px' }}>
        <PasswordExpiryRadio
          passwordExpiryInMonths={passwordExpiryInMonths}
          setPasswordExpiryInMonths={setPasswordExpiryInMonths}
          passwordExpiryRadio={passwordExpiryRadio}
          setPasswordExpiryRadio={setPasswordExpiryRadio}
        />
      </div>

      <span style={{ display: 'inline-flex' }}>
        <button
          className="button"
          type="submit"
          onClick={(e) => handlePasswordExpiryAll(e)}
        >
          {LS.manageUsers.expiryAllUsers}
        </button>
        <button
          className="button"
          type="submit"
          onClick={(e) => handlePasswordExpiryNew(e)}
        >
          {LS.manageUsers.expiryNewUsers}
        </button>
      </span>
    </form>
  );
};

export default PasswordExpiryForm;
